import { render } from "./Images.vue?vue&type=template&id=7415f94b&ts=true"
import script from "./Images.vue?vue&type=script&lang=ts"
export * from "./Images.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src754147292/src/web-ext-galaxycorp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__